import React, { useState } from 'react';
import { Card, Button, Form, Dimmer } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import PutObject from '../../lib/putObject';

const PricingEditModal = ({ recordId, closeMainModal, reload }) => {
  const { data, loading, handleChange } = useFetch(`prices/${recordId}`);
  const [saveLoading, toggleSaveLoading] = useState(false)

  const saveEdit = async () => {
    toggleSaveLoading(true)

    const editedPricing = {
      _id: recordId,
      priceFrom: data.priceFrom,
      priceTo: data.priceTo,
      rewardPercent: data.rewardPercent,
      moveitPercentFromTravelerReward: data.moveitPercentFromTravelerReward,
      deliveryFees: data.deliveryFees
    }

    PutObject('prices', editedPricing).then(() => {
      toggleSaveLoading(false)
      if (typeof reload === 'function') {
        reload()
      }
      closeMainModal()
    });
  }

  return (
    <Card>
      <Dimmer active={loading} loader={loading}>
        <Card.Header>
          <Card.Title>Edit Pricing</Card.Title>
          <Card.Options>
            <Button size="sm" icon="x" onClick={() => closeMainModal()} />
          </Card.Options>
        </Card.Header>

        {!loading && data &&
          <Card.Body>
            <Form>
              <Form.FieldSet>
                <Form.Input
                  name='priceFrom'
                  label='Price From'
                  type="number"
                  placeholder=''
                  value={data['priceFrom']}
                  onChange={handleChange}
                />

                <Form.Input
                  name='priceTo'
                  label='Price To'
                  type="number"
                  placeholder=''
                  value={data['priceTo']}
                  onChange={handleChange}
                />

                <Form.Input
                  name='rewardPercent'
                  label='Reward Percentage'
                  type="number"
                  placeholder=''
                  value={data['rewardPercent']}
                  onChange={handleChange}
                />

                <Form.Input
                  name='moveitPercentFromTravelerReward'
                  label='Fees Percentage'
                  type="number"
                  placeholder=''
                  value={data['moveitPercentFromTravelerReward']}
                  onChange={handleChange}
                />

                <Form.Input
                  name='deliveryFees'
                  label='Delivery Fees'
                  type="number"
                  placeholder=''
                  value={data['deliveryFees']}
                  onChange={handleChange}
                />
              </Form.FieldSet>
            </Form>
          </Card.Body>
        }

        <Card.Footer>
          <div style={{ textAlign: 'right' }}>
            <Button
              color="primary"
              size="sm"
              className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
              onClick={saveEdit}
              disabled={saveLoading}
            >
              Edit
            </Button>
          </div>
        </Card.Footer>
      </Dimmer>
    </Card>
  )
}

export default PricingEditModal;